import { FormControl, FormLabel, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

/**
 * FormSection component for grouping form elements with a title
 * @param {Object} props - Component props
 * @param {string} props.title - Section title
 * @param {React.ReactNode} props.children - Section content
 * @returns {JSX.Element}
 */
export const FormSection = ({ title, children }) => (
  <Grid size="grow" sx={{ pb: 5 }}>
    <Typography sx={sectionTitleStyles}>{title}</Typography>
    {children}
  </Grid>
);

/**
 * FormSubSection component for grouping related form controls
 * @param {Object} props - Component props
 * @param {string} props.title - Subsection title
 * @param {React.ReactNode} props.children - Subsection content
 * @returns {JSX.Element}
 */
export const FormSubSection = ({ title, children }) => (
  <Grid mb={4}>
    <FormControl>
      <FormLabel sx={{ pb: 1 }}>{title}</FormLabel>
      {children}
    </FormControl>
  </Grid>
);

const sectionTitleStyles = {
  fontSize: "1.5rem",
  fontWeight: "bold",
  mb: 4,
};
